import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './index.css';

const Footer = () => {
    const location = useLocation();
    if (location.pathname === '/login') return null;

    return (
        <footer style={{
            background: '#0a0a1a',
            color: '#fff',
            padding: '40px 20px',
            marginTop: 'auto',
            borderTop: '1px solid #1f1f3a'
        }}>
            <div style={{
                maxWidth: '1200px',
                margin: '0 auto',
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                gap: '20px'
            }}>
                <div style={{ flex: '1 1 200px' }}>
                    <h3 style={{ color: '#00ccff', marginBottom: '15px' }}>NOTTSIFY</h3>
                    <p style={{ fontSize: '0.9rem', opacity: 0.8 }}>
                        AI-powered study notes generation platform. enhancing your learning experience.
                    </p>
                </div>

                <div style={{ flex: '1 1 200px' }}>
                    <h4 style={{ marginBottom: '15px', borderBottom: '2px solid #00ccff', display: 'inline-block', paddingBottom: '5px' }}>Quick Links</h4>
                    <ul style={{ listStyle: 'none', padding: 0 }}>
                        <li style={{ marginBottom: '8px' }}><Link to="/" style={{ color: '#ccc', textDecoration: 'none', transition: 'color 0.3s' }}>Home</Link></li>
                        <li style={{ marginBottom: '8px' }}><Link to="/subscription" style={{ color: '#ccc', textDecoration: 'none', transition: 'color 0.3s' }}>Pricing</Link></li>
                    </ul>
                </div>

                <div style={{ flex: '1 1 200px' }}>
                    <h4 style={{ marginBottom: '15px', borderBottom: '2px solid #00ccff', display: 'inline-block', paddingBottom: '5px' }}>Legal</h4>
                    <ul style={{ listStyle: 'none', padding: 0 }}>
                        <li style={{ marginBottom: '8px' }}><Link to="/terms" style={{ color: '#ccc', textDecoration: 'none', transition: 'color 0.3s' }}>Terms & Conditions</Link></li>
                        <li style={{ marginBottom: '8px' }}><Link to="/privacy" style={{ color: '#ccc', textDecoration: 'none', transition: 'color 0.3s' }}>Privacy Policy</Link></li>
                        <li style={{ marginBottom: '8px' }}><Link to="/subscription-policy" style={{ color: '#ccc', textDecoration: 'none', transition: 'color 0.3s' }}>Subscription Policy</Link></li>
                        <li style={{ marginBottom: '8px' }}><Link to="/refund-policy" style={{ color: '#ccc', textDecoration: 'none', transition: 'color 0.3s' }}>Refund Policy</Link></li>
                    </ul>
                </div>

                <div style={{ flex: '1 1 200px' }}>
                    <h4 style={{ marginBottom: '15px', borderBottom: '2px solid #00ccff', display: 'inline-block', paddingBottom: '5px' }}>Connect</h4>
                    <p style={{ fontSize: '0.9rem', opacity: 0.8 }}>
                        For any queries, contact: <br />
                        <a href="mailto:nottsify@gmail.com" style={{ color: '#00ccff', textDecoration: 'none' }}>nottsify@gmail.com</a>
                    </p>
                    <ul style={{ listStyle: 'none', padding: 0, marginTop: '15px' }}>
                        <li><Link to="/feedback" style={{ color: '#00ccff', textDecoration: 'none', transition: 'color 0.3s' }}>💬 Submit Feedback</Link></li>
                    </ul>
                </div>
            </div>

            <div style={{
                textAlign: 'center',
                marginTop: '40px',
                paddingTop: '20px',
                borderTop: '1px solid #1f1f3a',
                fontSize: '0.85rem',
                opacity: 0.6
            }}>
                &copy; {new Date().getFullYear()} Nottsify. All rights reserved. | Version 1.1.1
            </div>
        </footer>
    );
};

export default Footer;
